(function () {
    'use strict';

    const TRACKING_PARAMS = [
        'gclid', 'fbclid', 'msclkid', 'li_fat_id',
        'epik', 'visitor_id', 'ga_session_id', 'session_stitch_id',
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term',
        'utm_content'
    ];

    const ZOHO_FORM_DOMAIN = 'skjema.jeco.no';
    const STORAGE_KEY = 'jeco_tracking_params';

    function getUrlParameters() {
        const params = {};
        const urlParams = new URLSearchParams(window.location.search);

        TRACKING_PARAMS.forEach(param => {
            const value = urlParams.get(param);
            if (value) params[param] = value;
        });

        return params;
    }

    function saveParametersToSession(params) {
        if (Object.keys(params).length > 0) {
            try {
                const existingParams = getParametersFromSession();
                const mergedParams = { ...existingParams, ...params };
                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(mergedParams));
                console.log('[Jeco Relay v2] Saved/Merged parameters:', mergedParams);
            } catch (e) {
                console.error('[Jeco Relay v2] SessionStorage write error:', e);
            }
        }
    }

    function getParametersFromSession() {
        try {
            const stored = sessionStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : {};
        } catch (e) {
            console.error('[Jeco Relay v2] SessionStorage read error:', e);
            return {};
        }
    }

    function buildQueryString(params) {
        const pairs = [];
        for (const key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
            }
        }
        return pairs.join('&');
    }

    function initialize() {
        const currentParams = getUrlParameters();
        saveParametersToSession(currentParams);
        console.log('[Jeco Relay v2] Initialized and parameters captured.');
    }

    document.addEventListener('click', function (event) {

        const targetLink = event.target.closest('a[href*="' + ZOHO_FORM_DOMAIN + '"]');

        if (!targetLink) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        console.log('[Jeco Relay v2] Intercepted click on Zoho link.');

        const storedParams = getParametersFromSession();

        if (Object.keys(storedParams).length === 0) {
            console.log('[Jeco Relay v2] No parameters to append, navigating to original URL.');
            window.location.href = targetLink.href;
            return;
        }

        const originalHref = targetLink.getAttribute('href');
        const queryString = buildQueryString(storedParams);

        const separator = originalHref.includes('?') ? '&' : '?';
        const newHref = originalHref + separator + queryString;

        console.log('[Jeco Relay v2] Redirecting to:', newHref);

        window.location.href = newHref;

    }, true);

    initialize();
})();

